"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MuiSvgIcon = void 0;
var palette_1 = require("../../../theme/global/palette");
var typography_1 = require("../../../theme/global/typography");
exports.MuiSvgIcon = {
    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
        color: palette_1.palette.primary.main,
    },
    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
        color: palette_1.palette.secondary.main,
    },
    /* Styles applied to the root element if `color="action"`. */
    colorAction: {
        color: palette_1.palette.grey[800],
    },
    /* Styles applied to the root element if `color="error"`. */
    colorError: {
        color: palette_1.palette.error.main,
    },
    /* Styles applied to the root element if `color="disabled"`. */
    colorDisabled: {
        color: palette_1.palette.text.disabled,
    },
    /* Styles applied to the root element if `fontSize="inherit"`. */
    fontSizeInherit: {
        fontSize: 'inherit',
    },
    /* Styles applied to the root element if `fontSize="small"`. */
    fontSizeSmall: {
        fontSize: typography_1.typography.pxToRem(10),
    },
    /* Styles applied to the root element if `fontSize="large"`. */
    fontSizeLarge: {
        fontSize: typography_1.typography.pxToRem(35),
    },
};
